<template>
  <v-select
    :options="options"
    :reduce="option => option.value"
    :value="value"
    @input="setValue"
    :placeholder="$t('selects.weekdaysSelectPlaceholder')"
    :clearable="false"
  />
</template>

<script>
import { weekdayOptions } from '@/components/mixins/constants'

export default {
  props: {
    value: { type: String, default: '' },
  },
  computed: {
    options() {
      return weekdayOptions[this.$i18n.locale]
    },
  },
  methods: {
    setValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>
